import { createSharedComposable } from '@vueuse/core'
import {
  ABASERVICES_STATUS_SOURCE,
  DEEPCLOUD_STATUS_SOURCE,
  useServiceStatus,
} from '@deepcloud/service-status'

export const LIVE_STATUS_URLS = {
  abaservices: 'https://status.abaservices.ch',
  deepcloud: 'https://status.deepcloud.swiss',
} as const

export type LiveStatusSourceKey = keyof typeof LIVE_STATUS_URLS

export const useLiveStatus = createSharedComposable(() =>
  useServiceStatus([ABASERVICES_STATUS_SOURCE, DEEPCLOUD_STATUS_SOURCE]),
)
